import React from "react";

import { TMarketingBrand } from "../../../domain/models/MarketingContent";

export const GA_MEASUREMENT_ID = "G-7G04THG1T4";

export const SAIL_LEGAL_GA_MEASUREMENT_ID = "G-KN7E6DMFBK";

const MEASUREMENT_ID: Record<TMarketingBrand, string | null> = {
    sail_homes: GA_MEASUREMENT_ID,
    sail_legal: SAIL_LEGAL_GA_MEASUREMENT_ID,
};

export const CONSENT_COOKIE = "sh_analytics_consent";

const isProduction = (): boolean =>
    typeof process !== "undefined" && !!process.env && process.env.ACCOUNT_NAME === "propertybid-production";

const snippetFor = (measurementId: string): string => [
    "window.dataLayer = window.dataLayer || [];",
    "function gtag(){dataLayer.push(arguments);}",
    "gtag('consent', 'default', {",
    "'analytics_storage': 'denied',",
    "'ad_storage': 'denied',",
    "'ad_user_data': 'denied',",
    "'ad_personalization': 'denied'",
    "});",
    `if (document.cookie.split('; ').indexOf('${CONSENT_COOKIE}=granted') !== -1) {`,
    "gtag('consent', 'update', {'analytics_storage': 'granted'});",
    "}",
    "gtag('js', new Date());",
    `gtag('config', '${measurementId}');`,
].join("");

// `brand` is required on purpose. Defaulting it to sail_homes would let a future call site
// omit the prop and silently leak into the wrong property again, which is the bug this file
// exists to prevent -- so the compiler enforces the decision rather than a convention.
export const GoogleAnalytics = (props: { brand: TMarketingBrand }): JSX.Element | null => {
    const measurementId = MEASUREMENT_ID[props.brand];

    return measurementId === null ? null : renderTag(measurementId);
};

const renderTag = (measurementId: string): JSX.Element | null =>
    isProduction()
        ? <React.Fragment>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}></script>
            <script dangerouslySetInnerHTML={{ __html: snippetFor(measurementId) }}></script>
        </React.Fragment>
        : null;
